const userQueryKeys = {
  all: [{ scope: 'users' }] as const,
  companyUsers: (companyId: string) => [{ scope: 'users', companyId }] as const
}

export default userQueryKeys
